import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getConstants } from "../../reduxStore/actions/serverConstants";

import MakeAPICall from "../../apiCalls/common";

import { faqApiRoute } from "../../apiRoutes";

import ICButton from "../../components/button";
import CustomModal from "../../components/modal";
import Loader from "../../components/loader";

import FaqForm from "../../containers/FaqForm";
import CreateFaqForm from "../../containers/FaqForm/createFaqForm";

const PatientFaqs = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [showCreateFaqModal, setShowCreateFaqModal] = useState(false);
  const [resModalTitle, setResModalTitle] = useState("");
  const [showResModal, setShowResModal] = useState(false);

  const toggleCreateModal = () => {
    setShowCreateFaqModal(!showCreateFaqModal);
  };

  const createFaqFormSubmit = values => {
    toggleCreateModal();
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("query", values.question);
    formData.append("ans", values.answer);
    formData.append("type", "Patient");

    setApiCallParams({
      reqType: "POST",
      reqUrl: faqApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setResModalTitle("FAQ Added Successfully");
        setShowResModal(true);
        props.getConstants();
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setResModalTitle(err.message);
        //setShowResModal(true);
      }
    });
  };

  const updateFormSubmit = values => {
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("query", values.question);
    formData.append("ans", values.answer);
    formData.append("type", "Patient");

    setApiCallParams({
      reqType: "PUT",
      reqUrl: faqApiRoute + "/" + values.id,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setResModalTitle("FAQ Updated Successfully");
        setShowResModal(true);
        props.getConstants();
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setResModalTitle(err.message);
        //setShowResModal(true);
      }
    });
  };

  const deleteCurrFaq = values => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: faqApiRoute + "/" + values.id + "/Patient",
      successCallback: res => {
        setIsProcessing(false);
        setResModalTitle("FAQ Deleted Successfully");
        setShowResModal(true);
        props.getConstants();
      },
      failureCallback: err => {
        setIsProcessing(false);
       // setResModalTitle(err.message);
        //setShowResModal(true);
      }
    });
  };

  return (
    <div className="faq-list-container col-md-12">
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showResModal}
        cancelEvent={() => {
          setShowResModal(false);
          setResModalTitle("");
        }}
        modalBodyContent={<p className="text-center mb-0">{resModalTitle}</p>}
      />
      <CustomModal
        openModal={showCreateFaqModal}
        cancelEvent={toggleCreateModal}
        title="Add New FAQ"
        modalBodyContent={<CreateFaqForm onFormSubmit={createFaqFormSubmit} />}
        noFooterButtons={true}
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <ICButton clickEvent={toggleCreateModal} title="Add Patient FAQ" />
        <div className="list-container">
          {props.faqs.map((faq, index) => (
            <div key={index} className="list-item">
              <FaqForm
                questionNo={index + 1}
                faq={faq}
                onUpdateFormSubmit={updateFormSubmit}
                onFaqDelete={deleteCurrFaq}
              />
            </div>
          ))}
        </div>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getConstants: () => dispatch(getConstants())
});

export default connect(null, mapDispatchToProps)(PatientFaqs);

PatientFaqs.defaultProps = {
  faqs: []
};

PatientFaqs.propTypes = {
  faqs: PropTypes.array
};
